<template>
  <el-row>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="编号:"
                      prop="code">
          <el-input v-model.trim="searchForm.code"
                    placeholder="编号"></el-input>
        </el-form-item>
        <el-form-item label="类型:"
                      prop="type">
          <el-input v-model.trim="searchForm.type"
                    placeholder="类型"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button type="primary">导 出</el-button>
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData">
        <el-table-column type="index"
                         label="序号"
                         width="60"></el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="item.prop === 'pass'">
              <el-tag v-if="scope.row[item.prop] === 0"
                      type="danger">拒绝</el-tag>
              <el-tag v-else
                      type="success">允许</el-tag>
            </template>
            <template v-else-if="item.prop === 'online'">
              <el-tag v-if="scope.row[item.prop] === 0"
                      type="danger">脱网</el-tag>
              <el-tag v-else
                      :underline="false"
                      type="success">联网</el-tag>
            </template>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
  </el-row>
</template>

<script>
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { Pagination },
  data() {
    return {
      searchForm: {
        code: '',
        type: ''
      },
      tableTitle: [
        {
          prop: 'code',
          name: '编号',
          width: '80'
        },
        {
          prop: 'device_type',
          name: '类型',
          width: '80'
        },
        {
          prop: 'gateway',
          name: '网关',
          width: '80'
        },
        {
          prop: 'csn',
          name: 'CSN',
          width: '80'
        },
        {
          prop: 'pass',
          name: '通行状态',
          width: '80'
        },
        {
          prop: 'online',
          name: '联网/脱网',
          width: '80'
        },
        {
          prop: 'room',
          name: '房间',
          width: '100'
        },
        {
          prop: 'person',
          name: '人员',
          width: '100'
        },
        {
          prop: 'num',
          name: '人员编号',
          width: '100'
        },
        {
          prop: 'user_type',
          name: '类别',
          width: '80'
        },
        {
          prop: 'building',
          name: '机构',
          width: '100'
        },
        {
          prop: 'time',
          name: '时间',
          width: '120'
        }
      ],
      tableData: [
        {
          code: '1001',
          device_type: '指纹设备',
          gateway: '小李啊',
          csn: 12345678,
          pass: 1,
          online: 0,
          room: '静园3楼301室',
          person: '小车',
          num: '20200101',
          user_type: '学生',
          building: '2020级计算机系',
          time: '2020-09-09 08:00:12'
        },
        {
          code: '1002',
          device_type: '指纹设备',
          gateway: '小李子',
          csn: 12345678,
          pass: 1,
          online: 0,
          room: '静园3楼301室',
          person: '小车',
          num: '20200101',
          user_type: '学生',
          building: '2020级计算机系',
          time: '2020-09-09 08:00:12'
        },
        {
          code: '1003',
          device_type: '指纹设备',
          gateway: '小李哇',
          csn: 12345678,
          pass: 0,
          online: 1,
          room: '静园3楼301室',
          person: '小车',
          num: '20200101',
          user_type: '学生',
          building: '2020级计算机系',
          time: '2020-09-09 08:00:12'
        }
      ],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 添加维修相关
      showRepairModal: false,
      repairData: {
        type: 'add'
      },
      // 维修记录相关
      showDealModal: false,
      dealData: {
        id: -1
      }
    }
  },
  methods: {
    // 获取列表
    getList() {
      // let start = (this.pagination.currentPage - 1) * this.pagination.perPage
      // fetch
      //   .getStaffList({
      //     start: start,
      //     limit: this.pagination.perPage,
      //     ...this.searchForm
      //   })
      //   .then((data) => {
      //     data.procData(
      //       data.res,
      //       (data) => {
      //         this.pagination.total = data.count
      //         this.tableData = data.result
      //       },
      //       (err) => {
      //         this.$message.error(err)
      //       }
      //     )
      //   })
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    }
  }
}
</script>

<style></style>
